import { ReactNode } from 'react';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { cn } from '../../lib/utils';

export interface TabItem {
  label: string;
  value: string;
  content: ReactNode;
  disabled?: boolean;
  icon?: ReactNode;
}

export interface TabsProps {
  items: TabItem[];
  defaultValue?: string;
  value?: string;
  onChange?: (value: string) => void;
  fullWidth?: boolean;
}

export function Tabs({
  items,
  defaultValue,
  value,
  onChange,
  fullWidth = false
}: TabsProps) {
  const defaultIndex = defaultValue 
    ? items.findIndex(item => item.value === defaultValue)
    : 0;
    
  const selectedIndex = value 
    ? items.findIndex(item => item.value === value)
    : defaultIndex;

  return (
    <TabGroup 
      selectedIndex={value ? selectedIndex : undefined}
      defaultIndex={defaultIndex}
      onChange={(index) => onChange?.(items[index].value)}
    >
      <TabList className={cn("tabs", fullWidth && "w-full")}>
        <div className="tabs-list">
          {items.map((item) => (
            <Tab
              key={item.value}
              disabled={item.disabled}
              className={({ selected }) =>
                cn(
                  "tabs-trigger",
                  selected && "[data-state=active]",
                  item.disabled && "opacity-50 cursor-not-allowed",
                  fullWidth && "flex-1"
                )
              }
            >
              {item.icon && (
                <span className="mr-2 inline-flex">{item.icon}</span>
              )}
              {item.label}
            </Tab>
          ))}
        </div>
      </TabList>
      <TabPanels className="mt-6">
        {items.map((item) => (
          <TabPanel
            key={item.value}
            className="focus-ring"
          >
            {item.content}
          </TabPanel>
        ))}
      </TabPanels>
    </TabGroup>
  );
}